export const PRIVACY_LAST_UPDATED = 'October 11, 2026';

export const PRIVACY_CONTACT_EMAIL = 'admin@chitragupta.co';

export const privacySections = [
  {
    id: 'introduction',
    title: 'Introduction',
    blocks: [
      'Chitragupta Urban Technologies Private Limited (“Chitragupta”, “us”, “we”, or “our”) operates chitragupta.co (hereinafter referred to as “Site”).',
      'Our Privacy Policy (“Policy”) governs your visit to chitragupta.co, and explains how we collect, safeguard, and disclose information that results from your use of our Site.',
      'We use your data to provide and improve our Site. By using our Site, you agree to the collection and use of information in accordance with this policy. The Policy also lays down how we may collect, use and share any information you provide. Chitragupta reserves the right, at its discretion, to change, modify, add or remove portions of this Policy at any time. Chitragupta recommends that you review this Policy periodically to ensure that you are aware of the current privacy practices.',
      'This Policy shall be construed as provided in compliance with Information Technology Act, 2000 as amended and read with the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011.',
    ],
  },
  {
    id: 'information-we-collect',
    title: 'Information We Collect',
    blocks: [
      'We collect the following types of personal data and information:',
      {
        list: [
          { term: 'Personal Identification Information:', text: 'This includes your name, email address, phone number, and any other details you provide when registering or contacting us.' },
          { term: 'Enquiry Information:', text: 'When you submit the contact form on our Site, we collect your name, organisation or city, role, email address, and the message you write to us. We also record which part of the Site your enquiry came from, for example a general contact request or a request for case studies.' },
          { term: 'Technical Data:', text: 'This includes your IP address, browser type, device information, and location data, which help us improve the performance and functionality of our Site.' },
          { term: 'Usage Data:', text: 'This includes information about how you interact with our Site, such as pages viewed, links clicked, time spent on the Site, and search queries, which help us understand and enhance user engagement.' },
        ],
      },
    ],
  },
  {
    id: 'use-of-information',
    title: 'Use of Information',
    blocks: [
      'We use the information we collect for the following purposes:',
      {
        list: [
          { term: 'To provide and improve our Site:', text: 'We use your data to ensure the Site functions smoothly, enhance features, and address technical issues to deliver a seamless user experience.' },
          { term: 'To communicate with you regarding updates, offers, and customer support:', text: 'Your contact information helps us send you important notifications, promotional content, and respond to inquiries or issues related to our Site.' },
          { term: 'To respond to your enquiries:', text: 'We use the details you share through our contact form to reply to you, discuss a pilot for your municipality or organisation, and send you the case studies you request.' },
          { term: 'To personalise your experience and tailor content to your preferences:', text: 'We analyse your browsing and usage data to offer content, recommendations, and features that best match your needs and interests, making your experience more relevant and enjoyable.' },
          { term: 'To monitor Site performance and conduct analytics:', text: 'We use collected data to track Site performance, user engagement, and behaviour, enabling us to optimise functionality, resolve issues, and improve the overall user experience.' },
          { term: 'To comply with legal obligations, including those under the Information Technology Act, 2000, and the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011:', text: 'We process your data to meet legal requirements, safeguard personal data, and ensure compliance with applicable laws governing data protection in India.' },
        ],
      },
    ],
  },
  {
    id: 'cookies',
    title: 'Cookies',
    blocks: [
      'Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer\'s storage drive.',
      'Like many other websites, we use “cookies” to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our website to their full potential.',
      'Examples of Cookies we use:',
      {
        list: [
          { term: 'Session Cookies:', text: 'We use Session Cookies to operate our Site.' },
          { term: 'Preference Cookies:', text: 'We use Preference Cookies to remember your preferences and various settings.' },
          { term: 'Security Cookies:', text: 'We use security cookies for security purposes.' },
          { term: 'Advertising Cookies:', text: 'Advertising Cookies are used to serve you with advertisements that may be relevant to you and your interests.' },
        ],
      },
      'We use cookies from third-party partners such as Google Analytics for marketing and analytical purposes. Google Analytics helps us understand how our customers use our Site.',
    ],
  },
  {
    id: 'data-retention',
    title: 'Data Retention',
    blocks: [
      'Your personal information will be stored and retained by us for a reasonable period after we accomplish the purpose for which it was collected, in accordance with applicable law. Please note that certain datasets may be subject to shorter retention periods as may be prescribed by applicable laws. In such cases, we shall comply with these requirements.',
    ],
  },
  {
    id: 'transfer-of-data',
    title: 'Transfer of Data',
    blocks: [
      'Your information, including personal information, may be transferred to and maintained on computers located in India. If you are located outside India and choose to provide information to us, please note that we transfer the corresponding data, to India and process it there.',
      'We will take all the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Policy and no transfer of your personal information will take place to an organisation or a country unless there are adequate controls in place including the security of your data and other personal information.',
      'Information you submit through the contact form on our Site is processed and stored using services provided by Google LLC, whose servers may be located outside India.',
    ],
  },
  {
    id: 'disclosure-of-data',
    title: 'Disclosure of Data',
    blocks: [
      'We may disclose personal information that we collect, or you provide:',
      {
        list: [
          { term: 'Disclosure for Law Enforcement:', text: 'Under certain circumstances, we may be required to disclose your personal information if required to do so by law or in response to valid requests by public authorities.' },
          { term: 'Other cases.', text: 'We may disclose your information also to our subsidiaries and affiliates; to contractors, service providers, and other third parties we use to support our business; to fulfil the purpose for which you provide it; for any other purpose disclosed by us when you provide the information; with your consent in any other cases; if we believe disclosure is necessary or appropriate to protect the rights, property, or safety of the Chitragupta, our customers, or others.' },
        ],
      },
    ],
  },
  {
    id: 'security-of-data',
    title: 'Security of Data',
    blocks: [
      'The security of your data is important to us but remember that no method of transmission over the internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security. We adopt industry standard security measures and keep updating our systems from time to time to protect your personal information against any hacking or virus dissemination. Users are responsible for ensuring the protection of login and password records for their account.',
    ],
  },
  {
    id: 'service-providers',
    title: 'Service Providers',
    blocks: [
      'We may employ third party companies and individuals to facilitate our Site, provide any services on our behalf, perform Site-related services or assist us in analysing how our Site is used.',
      'These third parties have access to your personal information only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose. These third parties will be required to follow this Policy with respect to your personal information.',
      'The service providers we currently use on our Site include:',
      {
        list: [
          { term: 'Google Apps Script:', text: 'Submissions from our contact form are sent to and stored using Google Apps Script, a service provided by Google LLC, so that our team can receive and respond to your enquiry.' },
          { term: 'Google Fonts:', text: 'Our Site loads fonts from Google Fonts. When you visit the Site, your browser connects to Google’s servers to download these fonts, which shares your IP address and browser information with Google.' },
        ],
      },
    ],
  },
  {
    id: 'analytics',
    title: 'Analytics',
    blocks: [
      'We may use third-party service providers to monitor and analyse the use of our Site.',
    ],
  },
  {
    id: 'links-to-other-sites',
    title: 'Links to Other Sites',
    blocks: [
      'Our Site may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party’s site. We strongly advise you to review the Policy of every site you visit. We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.',
    ],
  },
  {
    id: 'childrens-privacy',
    title: 'Children’s Privacy',
    blocks: [
      'Our Site is not intended for use by children under the age of 18 (“Child” or “Children”).',
      'We do not knowingly collect personally identifiable information from Children under 18. If you become aware that a Child has provided us with personal information, please contact us. If we become aware that we have collected personal information from Children without verification of parental consent, we will take steps to remove that information from our servers.',
    ],
  },
  {
    id: 'your-rights',
    title: 'Your Rights',
    blocks: [
      'Under the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011, you have the right to:',
      {
        list: [
          'Access, correct, or delete your personal data;',
          'Withdraw your consent to data processing at any time;',
          'Opt-out of marketing communications by clicking the unsubscribe link in emails;',
          'Request information about how your data is being used and with whom it is being shared; and',
          `To exercise your rights or if you have any questions about your data, please contact us at ${PRIVACY_CONTACT_EMAIL}`,
        ],
      },
    ],
  },
  {
    id: 'changes-to-this-policy',
    title: 'Changes to This Policy',
    blocks: [
      'We may update this Policy from time to time. Any changes will be posted on this page with an updated effective date. We recommend that you review this Policy periodically to stay informed about how we are protecting your information.',
    ],
  },
  {
    id: 'contact-information',
    title: 'Contact Information',
    blocks: [
      'If you have any questions or concerns about this Policy, or if you wish to exercise your data protection rights, please contact us at:',
      {
        address: [
          'Chitragupta Urban Technologies Private Limited',
          'CA-12,',
          'BHIVE Premium Whitefield Campus,',
          'Jbr Tech Park, Plot No. 77, 6th Rd, EPIP Zone, Whitefield, Bengaluru, Karnataka 560066',
          PRIVACY_CONTACT_EMAIL,
        ],
      },
    ],
  },
];
